import React from 'react';
import { connect } from 'react-redux';
import Mixpanel from 'helpers/Mixpanel.js';
import { logEvent } from 'actions/userAnalytics.js';
import { Page, PageBody } from '@bit/knotchinc.web-react-components.page';
import OnboardingModal from 'components/Modals/OnboardingModal/OnboardingModal.jsx';
import { preFetchLibraryPage } from 'components/Pages/Library/actions.js';
import { preFetchSearchPage } from 'components/Pages/SearchFeed/actions.js';
import { TrendingBrands, TrendingPublishers, TrendingKeywords } from './TrendingLists';
import { FollowedEntityFeed } from './FollowedEntityFeed';
import SearchHeader from './SearchHeader/SearchHeader.jsx';
import { TrendingListsContainer } from './styled.js';
import AddEntitiesSection from './AddEntitiesSection/AddEntitiesSection.jsx';

export class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      onboardingModalOpened: false,
    };
  }

  componentDidMount() {
    const { logPageView } = this.props;
    logPageView();
    Mixpanel.track('Viewed Home Page');
    // if (window.fetchCache && window.fetchCache.settings && window.fetchCache.settings.toggled) {
    //   setTimeout(() => preFetchLibrary().then(() => setTimeout(() => preFetchSearch(), 3000)), 2000);
    // }
  }

  componentDidUpdate(prevProps) {
    const shown = this.props.showOnboarding;
    if (prevProps.showOnboarding !== shown && shown) {
      this.setState({ onboardingModalOpened: true });
    }
  }

  render() {
    const { onboardingModalOpened } = this.state;
    const closeModal = () => this.setState({ onboardingModalOpened: false });

    return (
      <Page>
        <SearchHeader />
        <PageBody maxWidth="1300px">
          <TrendingListsContainer>
            <TrendingPublishers />
            <TrendingBrands />
            <TrendingKeywords />
          </TrendingListsContainer>
          <AddEntitiesSection />
          <FollowedEntityFeed />
        </PageBody>
        <OnboardingModal isOpen={onboardingModalOpened} close={closeModal} />
      </Page>
    );
  }
}
const mapStateToProps = ({ Home: { showOnboarding } }) => ({ showOnboarding });

const mapDispatchToProps = dispatch => ({
  preFetchLibrary: () => dispatch(preFetchLibraryPage()),
  preFetchSearch: () => dispatch(preFetchSearchPage()),
  logPageView: () => dispatch(logEvent({ event_type: 'page_view', page_type: 'home' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
